import { useDebounceEffect, useSetState, useDebounceFn } from 'ahooks';
import { FormInstance } from 'antd';
import { useEffect, useMemo } from 'react';
import Schema from 'async-validator';

interface useRowDataValidateProps {
  // 当前行数据
  value: any[];
  // 当前行定义
  columns: Array<{ dataIndex: string; isRequired?: boolean }>;
  formRef: any;
  /** 是否执行校验 */
  isShowRealtimeValidate: boolean;
}

export interface RowError {
  rowIndex: number;
  errors?: Array<{ field: string; message: string }>;
}
interface ValidateRowsfn {
  (validator: any, rows: any[]): Promise<Array<RowError>>;
}

const validateRows: ValidateRowsfn = async function (validator, rows) {
  const promiseArray: Array<Promise<any>> = [];
  rows.forEach(((v, rowIndex) => {
    const validate = new Promise((resolve) => {
      validator.validate(v, (errors, fields) => {
        if (errors) {
          resolve({ rowIndex, errors });
        } else {
          resolve(null);
        }
      });
    });
    promiseArray.push(validate);
  }));
  const validateResult = await Promise.all(promiseArray);

  return validateResult.filter((r) => !!r);
};

export function useRowDataValidate({
  value,
  columns,
  isShowRealtimeValidate = false,
}: useRowDataValidateProps) {
  const [state, setState] = useSetState<{
    validateResult: RowError[] | null; // 初始为null，执行过一次后永远为数组
  }>({
    // 实时校验结果
    validateResult: null,
  });

  const validator = useMemo(() => {
    const descriptor: { [key: string]: any } = {};
    columns.forEach(col => {
      descriptor[col.dataIndex] = {
        required: col.isRequired,
      };
    });
    return new Schema(descriptor);
  }, [columns]);

  const {
    run,
  } = useDebounceFn(
    () => {
      if (!isShowRealtimeValidate) {
        return;
      }
      validateRows(validator, value).then(validateResult => {
        setState({ validateResult });
      });
      // console.log(value);
      // console.log(columns);
    },
    { wait: 500 },
  );

  useEffect(() => {
    run();
  }, [JSON.stringify(value), JSON.stringify(columns), isShowRealtimeValidate]);

  return {
    validateResult: state.validateResult,
    // 校验所有数据
    validateRows: async () => {
      const res = await validateRows(validator, value);
      if (res.length > 0) {
        throw res;
      }
      return null;
    },
  };
}
